import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/whatsapp";

const HIDDEN = [/^\/admin/, /^\/devis\//, /^\/payment\//, /^\/temporaire/, /^\/assurance-temporaire/, /^\/dashboard/];

export const mobileBarVisible = (pathname) => !HIDDEN.some((r) => r.test(pathname));

export const MobileActionBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const visible = mobileBarVisible(pathname);
  useEffect(() => {
    document.body.classList.toggle("has-mobile-bar", visible);
    return () => document.body.classList.remove("has-mobile-bar");
  }, [visible]);
  if (!visible) return null;

  const goQuote = () => {
    const scroll = (tries = 20) => {
      const el = document.getElementById("produits");
      if (el) el.scrollIntoView({ behavior: "smooth" });
      else if (tries > 0) setTimeout(() => scroll(tries - 1), 150);
    };
    if (pathname !== "/") navigate("/");
    scroll();
  };

  const item = "flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-xs font-semibold";
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] flex"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="mobile-action-bar">
      <a href="tel:+33148209827" className={`${item} text-[#102692]`} data-testid="mobile-bar-call"><Phone className="w-5 h-5" /> Appeler</a>
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={`${item} text-[#128C7E]`} data-testid="mobile-bar-whatsapp"><MessageCircle className="w-5 h-5" /> WhatsApp</a>
      <button type="button" onClick={goQuote} className={`${item} bg-[#F97316] text-white`} data-testid="mobile-bar-quote"><FileText className="w-5 h-5" /> Devis</button>
    </nav>
  );
};
